<template>
	<Col class="flex-1 flex-align-center ml-2">
		<h3 class="heavy one-row mb-11">{{ columnTitle }}</h3>
		<Col v-for="(tableRow, rowIndex) in cellsValues" :key="`table-key-cell-${rowIndex}-${cellKey}-${tableRow[cellKey]}`">
			<Col class="table-cell width-100 one-row" :class="{ 'mt-9': rowIndex > 0 }">
				<slot name="cell-content" v-bind:cellValue="tableRow[cellKey]">
					<h3 class="reg">{{ getCellValueDisplay(tableRow[cellKey]) }}</h3>
				</slot>
			</Col>
		</Col>
	</Col>
</template>
<script>
export default {
	name: 'AnalyticsTableColumn',
	props: {
		cellKey: { type: String },
		cellsValues: { type: Array },
		columnTitle: { type: String },
	},
	methods: {
		getCellValueDisplay(cellValue) {
			const val = Number(String(cellValue).replaceAll('%', ''));
			return isNaN(val) ? '-' : cellValue || '-';
		},
	},
};
</script>
<style scoped lang="scss">
.table-cell {
	min-height: 25px;
}
</style>
